import {InMemoryWebStorage, UserManager, type UserManagerSettings, WebStorageStateStore} from 'oidc-client-ts'

declare module '#app' {
    interface NuxtApp {
        $auth: UserManager
    }
}

declare module 'vue' {
    interface ComponentCustomProperties {
        $auth: UserManager
    }
}

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $auth: UserManager
    }
}

export default defineNuxtPlugin(({provide}) => {
    const runtimeConfig = useRuntimeConfig()
    const userStore = useUserStore()
    const config = {
        authority: runtimeConfig.public.fed.authority,
        client_id: runtimeConfig.public.fed.clientId,
        redirect_uri: `${window.location.origin}/token`,
        response_type: 'code',
        scope: 'profile openid',
        userStore: new WebStorageStateStore({store: new InMemoryWebStorage()})
    } as UserManagerSettings
    const userManager = new UserManager(config)

    userManager.events.addUserLoaded((user) => {
        userStore.firstName = user.profile.givenName as string ?? ''
        userStore.lastName = user.profile.familyName as string ?? ''
        userStore.uid = user.profile.uid as string ?? ''
        userStore.isAdmin = userIsAdmin(user.profile.role as string[] ?? [])
        const {gtag} = useGtag()
        gtag('set', 'user_id', user.profile.uid!)
    })

    provide('auth', userManager)
})
